import { t as ZepIcon } from "../ZepIcon-DpJgyrAI.mjs";
import { jsx } from "react/jsx-runtime";
// src/components/MapFill.tsx
const MapFillIcon = ZepIcon((props) => /* @__PURE__ */ jsx("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	...props,
	children: /* @__PURE__ */ jsx("path", {
		d: "m7 3.613-3.632 1.21A2 2 0 0 0 2 6.721v11.892a2 2 0 0 0 2.632 1.897L7 19.72V3.614ZM9 19.054V3a1 1 0 0 1 .316.051L15 4.946V21a1 1 0 0 1-.316-.051L9 19.054ZM17 20.387l3.633-1.21A2 2 0 0 0 22 17.279V5.387a2 2 0 0 0-2.633-1.897L17 4.28v16.107Z",
		fill: props.fill || "currentColor"
	})
}));
export { MapFillIcon };
